import { useEffect, useState } from "react";
import api from "@/lib/api";
import { notify } from "@/lib/toast";
import { logError } from "@/lib/logger";

async function loadAdminBundle() {
    const [sRes, uRes] = await Promise.all([api.get("/admin/stats"), api.get("/admin/users")]);
    return { stats: sRes.data, users: uRes.data };
}

async function loadUserDrill(userId) {
    const { data } = await api.get(`/admin/users/${userId}`);
    return data;
}

/** Loads platform-wide stats + users list (once, on mount). */
export function useAdminBundle() {
    const [stats, setStats] = useState(null);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        let cancelled = false;
        loadAdminBundle()
            .then(({ stats: s, users: u }) => {
                if (cancelled) return;
                setStats(s);
                setUsers(u);
            })
            .catch((err) => {
                logError("Failed to load admin data", err);
                notify("Failed to load admin data", "error");
            });
        return () => { cancelled = true; };
    }, []);

    return { stats, users };
}

/** Loads detailed drill-down data when a user row is selected. */
export function useUserDrill(selectedUser) {
    const [drillData, setDrillData] = useState(null);

    useEffect(() => {
        if (!selectedUser) { setDrillData(null); return; }
        let cancelled = false;
        loadUserDrill(selectedUser.id)
            .then((d) => { if (!cancelled) setDrillData(d); })
            .catch((err) => {
                logError("Drill-down failed", err);
                notify("Failed to load user details", "error");
            });
        return () => { cancelled = true; };
    }, [selectedUser]);

    return drillData;
}
